import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { csvUrl, getData } from '../CustomUtils'
import { BOSSCI_CASE_REPORT_QUERY } from '../../../graphql.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ParameterValues from '../ParameterValues.js'
import ResultsGrid from '../ResultsGrid.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import '../Custom.css'

const BOSSCI_CASE_REPORT = gql(BOSSCI_CASE_REPORT_QUERY)

export default function CaseCourtSurgeryReport({ location }) {
  console.log('CaseCourtSurgeryReport rendered:', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, BOSSCI_CASE_REPORT, 'bossciCaseReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    let resultRows = ''
    if (results.reportData.length > 0) {
      resultRows = ResultsGrid(results, 0, results.reportData[0].length-1, location, null, null, null, null, results.reportData[0].length-1, true)
    }
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('BosSci/bossciCaseReport/case_court_surgery_report', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white'}} >
          <ReportHeading title={'Case, Court, and Surgery Report'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} noNumberRow={true} />
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}